import { createReducer, on } from "@ngrx/store";
import { transactionAll, transactionCreate, transactionDelete, transactionList, transactionUpdate } from "./transaction.action";

export const INIT_STATE = {
  items: [],
};

export const reducerTransaction = createReducer(
  INIT_STATE,
  on(transactionAll, (state, { items }) => {
    return {
      ...state,
      allItems: [...items],
    };
  }),
  on(transactionList, (state, { items }) => {
    return {
      ...state,
      items: [...items],
    };
  }),
  on(transactionCreate, (state, { item }) => {
    return {
      ...state,
      items: [item, ...state.items],
    };
  }),
  on(transactionUpdate, (state, { item }) => {
    let index = state.items.findIndex((o) => o.id === item.id);

    const items = [...state.items];

    if (index > -1) {
      items[index] = item;
    }

    return {
      ...state,
      items: items,
    };
  }),
  on(transactionDelete, (state, { item }) => {
    let items = state.items.filter((o) => o.id !== item.id);

    return {
      ...state,
      items: items,
    };
  })
);
